module.exports = __webpack_public_path__ + "img/pals.0460f042.png";